// extracted by mini-css-extract-plugin
export default {"cls1":"ClJKB9PzPbL6aUWdwGaX","cls2":"SN8sFbzTWeKd6gSDaCSO ClJKB9PzPbL6aUWdwGaX"};